import { Pipe, PipeTransform } from '@angular/core';
import { SalesTrailerType } from '../internal/lane-tool/lane-tool.service';

const trailers: Record<SalesTrailerType, string> = {
  reefer: 'Reefer',
  dry_van: 'Dry Van',
  power_only: 'Power Only',
  flatbed: 'Flatbed',
  hopper: 'Hopper',
  pneumatic: 'Pneumatic',
  belly_dump: 'Belly Dump',
  end_dump: 'End Dump',
  straight_box: 'Straight Box',
};

@Pipe({
  name: 'toursTrailerTypePipe',
})
export class ToursTrailerTypePipe implements PipeTransform {
  public transform(value: SalesTrailerType | SalesTrailerType[]): string | string[] {
    if (Array.isArray(value)) {
      return value.map((v) => trailers[v]);
    }
    return trailers[value];
  }
}
